import { render, staticRenderFns } from "./MediaDatatable.vue?vue&type=template&id=0972b507"
import script from "./MediaDatatable.ts?vue&type=script&lang=ts&external"
export * from "./MediaDatatable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports